/**
 * @typedef {Object} SupplierCreateDto
 * @property {string} supplierCode
 * @property {string} supplierName
 * @property {string} [supplierType]
 * @property {string} [contactName]
 * @property {string} [contactEmail]
 * @property {string} [contactPhone]
 * @property {string} [billingAddress]
 * @property {string} [shippingAddress]
 * @property {string} [paymentTerms]
 * @property {string} [currency]
 * @property {string} [taxId]
 * @property {number} [leadTimeDays]
 * @property {number} [minOrderQty]
 * @property {number} [qualityRating]
 * @property {boolean} [isPreferred]
 * @property {boolean} [isApproved]
 */

/**
 * @typedef {Object} SupplierResponseDto
 * @property {number} supplierId
 * @property {string} supplierCode
 * @property {string} supplierName
 * @property {boolean} isActive
 * @property {number} componentCount
 */

const BASE_PATH = 'v1/Supplier';

export default function (instance) {
  return {
    getSuppliers(params = {}) {
      return instance.get(BASE_PATH, { params });
    },

    getSupplierLookups() {
      return instance.get(`${BASE_PATH}/lookups`);
    },

    getSupplier(id) {
      return instance.get(`${BASE_PATH}/${id}`);
    },

    createSupplier(payload) {
      return instance.post(BASE_PATH, payload);
    },

    updateSupplier(id, payload) {
      return instance.put(`${BASE_PATH}/${id}`, payload);
    },

    deleteSupplier(id) {
      return instance.delete(`${BASE_PATH}/${id}`);
    },

    // Supplier component price list
    getSupplierComponents(supplierId) {
      return instance.get(`${BASE_PATH}/${supplierId}/components`);
    },

    createSupplierComponent(supplierId, payload) {
      return instance.post(`${BASE_PATH}/${supplierId}/components`, payload);
    },

    updateSupplierComponent(supplierId, componentId, payload) {
      return instance.put(`${BASE_PATH}/${supplierId}/components/${componentId}`, payload);
    },

    deleteSupplierComponent(supplierId, componentId) {
      return instance.delete(`${BASE_PATH}/${supplierId}/components/${componentId}`);
    }
  };
}
